var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediumRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "medium-risk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GloepidOne",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "medium-risk",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Icon-BG",
    fill: "#FFEA8A",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("g", {
    id: "Polaris-icon/Major/2-Tone/Circle-Alert",
    transform: "translate(5.000000, 5.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Fill",
    cx: 9,
    cy: 9,
    r: 9
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6,14 C6,12.154 6.635,10.457 7.688,9.103 L18.897,20.312 C17.542,21.365 15.846,22 14,22 C9.589,22 6,18.411 6,14 M20.312,18.897 L9.103,7.688 C10.458,6.635 12.154,6 14,6 C18.411,6 22,9.589 22,14 C22,15.846 21.365,17.543 20.312,18.897 M4,14 C4,19.514 8.486,24 14,24 C19.514,24 24,19.514 24,14 C24,8.486 19.514,4 14,4 C8.486,4 4,8.486 4,14",
    id: "Mask",
    fill: "#8A6116"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumRisk);
export default __webpack_public_path__ + "static/media/medium-risk.202607afebd1fe6d4178d9db462f3ec0.svg";
export { ForwardRef as ReactComponent };